import { render, staticRenderFns } from "./widget-json.vue?vue&type=template&id=6cfb4e24&scoped=true&"
import script from "./widget-json.vue?vue&type=script&lang=js&"
export * from "./widget-json.vue?vue&type=script&lang=js&"
import style0 from "./widget-json.vue?vue&type=style&index=0&id=6cfb4e24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfb4e24",
  null
  
)

export default component.exports